'use client'

import { useLenis } from 'lenis/react'
import { usePathname } from 'next/navigation'
import { useEffect, useLayoutEffect, useRef } from 'react'
import scrollToTop from 'src/_helpers/client/scrollToTop'

const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect

const normalizePathname = (value) => {
  if (!value) return value

  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

const RouteScrollManager = ({ children }) => {
  const pathname = usePathname()
  const lenis = useLenis()
  const previousPathname = useRef(pathname)
  const popStatePathname = useRef(null)

  useEffect(() => {
    const handlePopState = () => {
      popStatePathname.current = normalizePathname(window.location.pathname)
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  useIsomorphicLayoutEffect(() => {
    if (previousPathname.current === pathname) return
    previousPathname.current = pathname

    const poppedPathname = popStatePathname.current
    popStatePathname.current = null

    if (poppedPathname === normalizePathname(pathname) || window.location.hash) return

    scrollToTop(lenis)
  }, [lenis, pathname])

  return children
}

export default RouteScrollManager
